module.exports = __webpack_public_path__ + "f0855fc638417efb9010fcd1620ae58d.svg";